import { createAsyncThunk } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/gatsby';
import { AxiosError } from 'axios';
import Axios from '../../utils/Axios';

export const fetchSelf = createAsyncThunk<
  User,
  { token?: string } | void,
  { rejectValue: AxiosError }
>('user/fetchSelf', async (params, { rejectWithValue }) => {
  try {
    const token =
      params && typeof params === 'object' ? params.token : undefined;
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const response = await Axios.get(`/contacts/me/`, config);

    if (response.status !== 200) {
      Sentry.captureException(response.data);
      return rejectWithValue(response.data as AxiosError);
    }
    return response.data;
  } catch (error) {
    Sentry.captureException(error);
    return rejectWithValue(error as AxiosError);
  }
});
